/**
 * 描述：multipleSelectModule 多选下拉
 * 日期：2019-03-27
 * 作者：Qian.qianchen
 */
"use strict";
angular.module("multipleSelectModule", []).
directive("multipleSelect", ["$timeout", function($timeout) {
    return {
        restrict: "E",
        repalace: false,
        scope: {
            selectName: '@',
            selectArray: '=',
            selectedChannel: '=',
            requestTableData: '&'
        },
        templateUrl: './editingCenter/directive/multipleSelect/multipleSelect_tpl.html',
        link: function($scope, $elem, $attrs) {
            initStatus();
            /**
             * [initStatus description] 初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    isShowSelectItems: false
                }
                initBlur();
            }
            /**
             * [isChecked description] 判断是否被选中
             * @param  {[object]}  item [description] 栏目对象
             * @return {Boolean}      [description]
             */
            $scope.isChecked = function(item) {
                return $scope.selectedChannel.some((_item, index) => {
                    return _item.CHANNELID == item.CHANNELID
                });
            }
            /**
             * [selectItem description] 选择栏目
             * @param  {[object]} item [description] 栏目对象
             * @return {[type]}      [description]
             */
            $scope.selectItem = function(item, ev) {
                if (ev) {
                    ev.stopPropagation();
                }
                if ($scope.isChecked(item)) {
                    $scope.selectedChannel = $scope.selectedChannel.filter((_item, index) => {
                        return item.CHANNELID != _item.CHANNELID;
                    });
                } else {
                    $scope.selectedChannel.push(item);
                }
                $scope.requestTableData();
            }
            /**
             * [selectAll description] 栏目全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function(ev) {
                if (ev) {
                    ev.stopPropagation();
                }
                if ($scope.selectArray.length > 0 && $scope.selectedChannel.length == $scope.selectArray.length) {
                    $scope.selectedChannel = [];
                } else {
                    $scope.selectedChannel = angular.copy($scope.selectArray);
                }
                // $scope.requestTableData();
            }
            $scope.showListToggle = function(ev) {
                ev.stopPropagation();
                $scope.status.isShowSelectItems = !$scope.status.isShowSelectItems;
                if ($scope.status.isShowSelectItems) {
                    $timeout(function() {
                        mouseWheelStop();
                    });
                }
            }
            /**
             * [initBlur description] 初始化失焦
             * @return {[type]} [description]
             */
            function initBlur() {
                $("body").bind("click", bindBody);
                $("body").bind("mousewheel", bindBody);
            }
            /**
             * [mouseWheelStop description] 在ul上阻止滚动事件冒泡
             * @return {[type]} [description]
             */
            function mouseWheelStop() {
                $elem.find("ul").bind("mousewheel", function($event) {
                    $event.stopPropagation();
                })
            }

            function bindBody(e) {
                $elem.blur();
                $scope.status.isShowSelectItems = false;
                // $elem.find('.select_list').css({'display':'none'});
                // $elem.find('.triangle_icon').addClass('show_triangle').removeClass('hidden_triangle');
                $scope.$apply();
            };
            $scope.$on("$destroy", function() {
                $("body").unbind("click", bindBody);
                $("body").unbind("mousewheel", bindBody);
            });
        }
    };
}]);